import { required, minLength, requiredIf } from 'vuelidate/lib/validators';
import { LABEL_VISIBILITY } from 'dashboard/helper/labelVisibility';

export const validLabelCharacters = (str = '') => !!str && !str.includes(' ');

export default {
  title: {
    required,
    minLength: minLength(2),
    validLabelCharacters,
  },
  description: {},
  color: {
    required,
  },
  showOnSidebar: {},
  teamId: {
    required: requiredIf(vm => vm.visibility === LABEL_VISIBILITY.TEAM),
  },
  inboxId: {
    required: requiredIf(vm => vm.visibility === LABEL_VISIBILITY.INBOX),
  },
};
